import { reconfigureApi } from '../../utilities/configureApi'

declare const window
interface IJavaScriptInterface {
  enableHeader(): void
  disableHeader(): void
  loadUrl(aString: string): void
}

declare const AndroidDasherClient: IJavaScriptInterface

export const enableHeader = () => {
  AndroidDasherClient.enableHeader()
}

export const disableHeader = () => {
  AndroidDasherClient.disableHeader()
}

/**
 * Loads a URL in the Android device via an app-switch to the browser
 *
 * @param {string} url
 */
export const loadUrl = (url: string) => {
  AndroidDasherClient.loadUrl(url)
}

/**
 * not all android clients will be able to provide a unique link. Unique links
 * are provided for the onboarding webview flow. The delivery issues flow does
 * not have a uniquelink to pass.
 */
export const requestCredentials = loadApplication => {
  const token = window.webview ? window.webview.token : null
  const uniqueLink = window.webview ? window.webview.uniqueLink : null

  if (!token) {
    throw new Error('Webview Android token undefined')
  }

  reconfigureApi(token)
  loadApplication(uniqueLink)
}
